import store from '../app/store';
import { selectShortTermJWT } from '../app/slices/session.slice';
import { IRequestInterceptor, JWTRequestInterceptor } from './RequestInterceptors';
import { ApiService } from '../api/axios';

const EMAIL_PATH = 'check/email';

interface ErrorResponse {
	error?: Array<{ msg: string }>;
}

export class EmailService {
	private _jwtInterceptor: IRequestInterceptor;

	constructor(interceptor: IRequestInterceptor) {
		this._jwtInterceptor = interceptor;
	}

	public async sendEmailAddress(email: string): Promise<void> {
		const formData = new URLSearchParams();
		formData.append('email', email);

		this._jwtInterceptor.interceptRequest(this.putEmailAddress(formData));
	}

	public putEmailAddress(formData: URLSearchParams): () => Promise<any> {
		return async () => {
			try {
				const response = await ApiService.put(EMAIL_PATH, formData.toString(), {
					headers: {
						Authorization: selectShortTermJWT(store.getState())
					}
				});

				const responseData = response.data as ErrorResponse;

				if (hasInvalidValueError(responseData)) {
					throw new InvalidEMailValueError();
				} else {
					return response;
				}
			} catch (error) {
				if (isNotAcceptableStatus(error)) throw new CheckUpdateNotAcceptableError();
				throw error;
			}
		};
	}
}

const jwtRequestInterceptor = new JWTRequestInterceptor();
export const emailAPI = new EmailService(jwtRequestInterceptor);

export class InvalidEMailValueError extends Error {
	constructor() {
		super('Invalid email value');
	}
}

export class CheckUpdateNotAcceptableError extends Error {
	constructor() {
		super('Check update not acceptable');
	}
}

const hasInvalidValueError = (responseData: ErrorResponse): boolean | undefined => {
	return responseData.error && responseData.error.length > 0 && responseData.error[0].msg === 'Invalid value';
};

const isNotAcceptableStatus = (error: any): boolean => {
	return error.response && error.response.status === 406;
};
